import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import * as VendorService from "../../../services/vendors/index";

export const fetchAllVendors = createAsyncThunk(
    "vendors/fetchAll",
    async (_, thunkAPI) => {
        try {
            const result = await VendorService.fetchAllVendors();
            console.log("vendor response : ", result);
            if (result?.success) {
                return result?.data || [];
            } else {
                return thunkAPI.rejectWithValue(result?.message || "Failed to fetch vendors");
            }
        } catch (err) {
            console.log("Error in fetchAllVendors : ", err);
            return thunkAPI.rejectWithValue(err?.message || "Internal Server Error.");
        }
    }
);

export const getVendorAccounts = createAsyncThunk(
    "vendors/fetchAccounts",
    async (payload, thunkAPI) => {
        try {
            const result = await VendorService.fetchAllVendorAccounts(payload);
            console.log("vendor account response : ", result);
            if (result?.success) {
                return result?.data || [];
            } else {
                return thunkAPI.rejectWithValue(result?.message || "Failed to fetch vendor accounts");
            }
        } catch (err) {
            console.log("Error in getVendorAccounts : ", err);
            return thunkAPI.rejectWithValue(err?.message || "Internal Server Error.");
        }
    }
);

const initialState = {
    vendors: [],
    vendorAccounts: [],
    loading: false,
    error: null,
};

const vendorSlice = createSlice({
    name: "Vendor",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            // Fetch Vendors
            .addCase(fetchAllVendors.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchAllVendors.fulfilled, (state, action) => {
                state.loading = false;
                state.vendors = action.payload;
            })
            .addCase(fetchAllVendors.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })

            // Fetch Vendor Accounts
            .addCase(getVendorAccounts.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(getVendorAccounts.fulfilled, (state, action) => {
                state.loading = false;
                state.vendorAccounts = action.payload;
            })
            .addCase(getVendorAccounts.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });
    },
});

export const vendorReducer = vendorSlice.reducer;
